<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 2/Bold'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126912&m=dev'
*/

defineOptions({
  name: 'TextSecondaryMedium',
})

withDefaults(defineProps<TextSecondaryMediumProps>(), {
  is: 'div',
})

interface TextSecondaryMediumProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-secondary-medium"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="./TextSecondaryMedium.scss" />
